var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('LineChart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"height":400}}),(_vm.loading)?_c('Loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }